import { createContext } from 'react';

const ContentContext = createContext(false);

export default ContentContext;
